/**
 * @generated SignedSource<<79b26bc91e55bca99e97e647fc76cc14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesEditorInit_package$data = {
  readonly cateringOptions: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly rooms: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorCateringSettings_package" | "RoomRatesEditorRoomSettings_package">;
  readonly " $fragmentType": "RoomRatesEditorInit_package";
};
export type RoomRatesEditorInit_package$key = {
  readonly " $data"?: RoomRatesEditorInit_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesEditorInit_package">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesEditorInit_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CateringOption",
      "kind": "LinkedField",
      "name": "cateringOptions",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Room",
      "kind": "LinkedField",
      "name": "rooms",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesEditorRoomSettings_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoomRatesEditorCateringSettings_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};
})();

(node as any).hash = "c62e4c05ed7ed32febd7c6711fd7defd";

export default node;
